import * as React from "react";
import type { SVGProps } from "react";
const SvgTicketWithPercentage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.55 16.89A.93.93 0 0 0 10 17a1 1 0 0 0 .89-.55l4-8a1 1 0 0 0-1.78-.9l-4 8a1 1 0 0 0 .44 1.34"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 17a3 3 0 1 1 0-5.999A3 3 0 0 1 16 17m0-4a1 1 0 1 0 0 2.002A1 1 0 0 0 16 13M6.333 12.494a3 3 0 1 0 3.333-4.988 3 3 0 0 0-3.333 4.988M7.444 9.17a1 1 0 1 1 1.112 1.663 1 1 0 0 1-1.112-1.663"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 21h18a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1 1 1 0 0 1 0-2 1 1 0 0 0 1-1V6a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v4a1 1 0 0 0 1 1 1 1 0 0 1 0 2 1 1 0 0 0-1 1v4a3 3 0 0 0 3 3m-1-3v-3.17a3 3 0 0 0 0-5.66V6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3.17a3 3 0 0 0 0 5.66V18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTicketWithPercentage;
